import React from 'react'

const UsersPremium = () => {}

export default UsersPremium
